import { WhatsAppOutlined } from '@ant-design/icons';
import { Button, Modal } from 'antd';
import React, { useContext, useEffect } from 'react';
import { ParamsContext } from '../../Context/ParamsContext';

const RegistrationWhatsappNotification = ({ passport }) => {
  const isProjectSwitch = passport.active_project && passport.actions.waiting_for_verification;

  const { new_passport } = useContext(ParamsContext);

  useEffect(() => {
    if (new_passport) {
      showNotificationModal();
    }
  }, [new_passport])

  const showNotificationModal = () => {
    Modal.success({
      title: isProjectSwitch ? `Pindah Proyek` : `Registrasi Personel Baru`,
      content: (
        <div>
          Silakan kirimkan notifikasi ke PIC proyek atau Admin QHSE melalui Whatsapp.
        </div>
      ),
      okText: "Kirimkan Notifikasi",
      okCancel:true,
      onOk() {
        //redirect to wa.me, then reload the detail page
        const whatsappUrl = isProjectSwitch ? passport.whatsapp.switch_project.url : passport.whatsapp.registration.url;
        window.open(whatsappUrl, '_blank');
        if (window.reloadDetail) {
          window.reloadDetail();
        }
      }
    });
  }

  return (
    <Button type="default" size="small" icon={<WhatsAppOutlined />} onClick={() => showNotificationModal()}>{isProjectSwitch ? `Kirim Notifikasi Pindah Proyek` : `Kirim Notifikasi Registrasi`}</Button>
  );
}

export default RegistrationWhatsappNotification;